export default __webpack_public_path__ + "static/media/adelphic_icon.a849c73e.jpeg";